// Shared mock state for surgery-pre-post-preparation forms

export type FormDataType = {
  teslimTarihiPre: string;
  teslimEdenPre: string;
  teslimAlanPre: string;
  kayitYapanKullanici: string;
  bolgeIsaretlemesiTarih: string;
  bolgeIsaretlemesiYapildiMiRadio: string;
  bolgeIsaretlemesiCheckbox: {
    bilateral: boolean;
    sag: boolean;
    tekliOrgan: boolean;
    sol: boolean;
    seviye : boolean;
  };
  bolgeIsaretlemesiSeviye: string;
  bolgeIsaretlemesiAciklama: string;
  alerjisiVarMiRadio: string;
  alerjiAciklama: string;
  onamFormuImzaVarMiRadio: string;
  onamFormuAciklama: string;
  anesteziHekimiDegerlendirmesiRadio: string;
  anesteziHekimiDegerlendirmesiCheckbox: {
    lokalAnesteziYapilacak: boolean;
    diger: boolean;
    oncedenYapilmis: boolean;
  };
  anesteziHekimiDegerlendirmesiAciklama: string;
  laboratuvarTetkikleriVarMiRadio: string;
  laboratuvarTetkikleriOncedenYapilmis: boolean;
  laboratuvarTetkikleriAciklama: string;
  radyolojiTetkikleriVarMiRadio: string;
  radyolojiTetkikleriCheckbox: {
    akcigerGrafisi: boolean;
    diger: boolean;
    oncedenYapilmis: boolean;
  };
  radyolojiTetkikleriAciklama: string;
  kurumDisiTetkiklerVarMiRadio: string;
  kurumDisiTetkiklerAciklama: string;
  bulasiciHastaligiVarMiRadio: string;
  bulasiciHastaligiAciklama: string;
  hastaAcMiRadio: string;
  hastaAcMiCheckbox: {
    hastaYemis: boolean;
    diger: boolean;
  };
  hastaAcMiAciklama: string;
  ameliyatBolgesiTrasiYapildiMiRadio: string;
  ameliyatBolgesiTrasiCheckbox: {
    hastaIstemedi: boolean;
    ameliyatBolgesiTemiz: boolean;
    ameliyathanedeYapilacak: boolean;
  };
  konsultasyonVarMiRadio: string;
  konsultasyonEvetIseCheckbox: boolean;
  konsultasyonAciklama: string;
  ameliyatOncesiUygulananIslemlerVarMiRadio: string;
  ameliyatOncesiUygulananIslemlerAciklama: string;
  ameliyatOncesiUygulananIslemlerCheckbox: {
    lavman: boolean;
    varisCorabi: boolean;
    ivKateteri: boolean;
    idrarKateteri: boolean;
    ng: boolean;
    vucutBanyosu: boolean;
  };
  makyajVeOjeVarMiRadio: string;
  makyajVeOjeAciklama: string;
  hastaKolBandiVarMiRadio: string;
  hastaKolBandiAciklama: string;
  protezVeyaDegerliEsyaVarMiRadio: string;
  protezVeyaDegerliEsyaCheckbox: {
    cikarildi: boolean;
    cikarilmadi: boolean;
  };
  protezVeyaDegerliEsyaAciklama: string;
  piercingVarMiRadio: string;
  piercingVarMiAciklama: string;
  mesaneBosaltildiMiRadio: string;
  mesaneBosaltildiMiAciklama: string;
  hastaTumCamAsirlariCikarildiMiRadio: string;
  hastaTumCamAsirlariCikarildiMiAciklama: string;
  hastaOnluguVeBonesiGiyiliMiRadio: string;
  hastaSedyeKemerleriBagliMiRadio: string;
  ilacUygulamalariVarMiRadio: string;
  ilacUygulamalariVarMiAciklama: string;
  premedikasyonUygulamalariYapildiMiRadio: string;
  premedikasyonUygulamalariCheckbox: {
    hastaIstemedi: boolean;
    lokalAnestezi: boolean;
  };
  premedikasyonUygulamalariAciklama: string;
  ameliyatSirasiKanUrunleriVarMiRadio: string;
  ameliyatSirasiKanUrunleriVarMiCheckbox: {
    varIse: boolean;
  };
  ameliyatSirasiKanUrunleriVarMiAciklama: string;
  teslimTarihiPost: string;
  teslimEdenPost: string;
  teslimAlanPost: string;
  operasyonDoktorAdi: string;
  ameliyatHemsiresi: string;
  ameliyatAdi: string;
  bolgeIsaretlemesiYapildiMiPostRadio: string;
  bolgeIsaretlemesiYapildiMiPostCheckbox: {
    bilateral: boolean;
    sag: boolean;
    tekliOrgan: boolean;
    sol: boolean;
  };
  bolgeIsaretlemesiYapildiMiPostAciklama: string;
  allerjiVarMiPostRadio: string;
  allerjiVarMiPostAciklama: string;
  pansumanTemizMiPostRadio: string;
  pansumanTemizMiPostAciklama: string;
  kanamaVarMiPostRadio: string;
  kanamaVarMiPostAciklama: string;
  herhangiBirDrenMevcutMuPostRadio: string;
  herhangiBirDrenMevcutMuPostCheckbox: {
    evetIseYeriVeMiktari: boolean;
  };
  herhangiBirDrenMevcutMuPostAciklama: string;
  folaySondaVarMiPostRadio: string;
  folaySondaVarMiPostAciklama: string;
  nazogastrikSondaVarMiPostRadio: string;
  nazogastrikSondaVarMiPostAciklama: string;
  ameliyathanedeUygulananIlaclarVarMiPostRadio: string;
  ameliyathanedeUygulananIlaclarVarMiPostAciklama: string;
  kanTransfuzyonuYapilmisMiPostRadio: string;
  kanTransfuzyonuYapilmisMiPostCheckbox: {
    evetIseKacUnite: boolean;
  };
  kanTransfuzyonuYapilmisMiPostAciklama: string;
  hastadanPatolojiOrnegiGonderilmisMiPostRadio: string;
  hastadanPatolojiOrnegiGonderilmisMiPostCheckbox: {
    evetIseKacUnite: boolean;
  };
  hastadanPatolojiOrnegiGonderilmisMiPostAciklama: string;
};

export const initialFormData: FormDataType = {
  teslimTarihiPre: "",
  teslimEdenPre: "",
  teslimAlanPre: "",
  kayitYapanKullanici: "",
  bolgeIsaretlemesiTarih: "",
  bolgeIsaretlemesiYapildiMiRadio: "",
  bolgeIsaretlemesiCheckbox: {
    bilateral: false,
    sag: false,
    tekliOrgan: false,
    sol: false,
    seviye : false
  },
  bolgeIsaretlemesiSeviye: "",
  bolgeIsaretlemesiAciklama: "",
  alerjisiVarMiRadio: "",
  alerjiAciklama: "",
  onamFormuImzaVarMiRadio: "",
  onamFormuAciklama: "",
  anesteziHekimiDegerlendirmesiRadio: "",
  anesteziHekimiDegerlendirmesiCheckbox: {
    lokalAnesteziYapilacak: false,
    diger: false,
    oncedenYapilmis: false
  },
  anesteziHekimiDegerlendirmesiAciklama: "",
  laboratuvarTetkikleriVarMiRadio: "",
  laboratuvarTetkikleriOncedenYapilmis: false,
  laboratuvarTetkikleriAciklama: "",
  radyolojiTetkikleriVarMiRadio: "",
  radyolojiTetkikleriCheckbox: {
    akcigerGrafisi: false,
    diger: false,
    oncedenYapilmis: false
  },
  radyolojiTetkikleriAciklama: "",
  kurumDisiTetkiklerVarMiRadio: "",
  kurumDisiTetkiklerAciklama: "",
  bulasiciHastaligiVarMiRadio: "",
  bulasiciHastaligiAciklama: "",
  hastaAcMiRadio: "",
  hastaAcMiCheckbox: {
    hastaYemis: false,
    diger: false
  },
  hastaAcMiAciklama: "",
  ameliyatBolgesiTrasiYapildiMiRadio: "",
  ameliyatBolgesiTrasiCheckbox: {
    hastaIstemedi: false,
    ameliyatBolgesiTemiz: false,
    ameliyathanedeYapilacak: false
  },
  konsultasyonVarMiRadio: "",
  konsultasyonEvetIseCheckbox: false,
  konsultasyonAciklama: "",
  ameliyatOncesiUygulananIslemlerVarMiRadio: "",
  ameliyatOncesiUygulananIslemlerAciklama: "",
  ameliyatOncesiUygulananIslemlerCheckbox: {
    lavman: false,
    varisCorabi: false,
    ivKateteri: false,
    idrarKateteri: false,
    ng: false,
    vucutBanyosu: false
  },
  makyajVeOjeVarMiRadio: "",
  makyajVeOjeAciklama: "",
  hastaKolBandiVarMiRadio: "",
  hastaKolBandiAciklama: "",
  protezVeyaDegerliEsyaVarMiRadio: "",
  protezVeyaDegerliEsyaCheckbox: {
    cikarildi: false,
    cikarilmadi: false
  },
  protezVeyaDegerliEsyaAciklama: "",
  piercingVarMiRadio: "",
  piercingVarMiAciklama: "",
  mesaneBosaltildiMiRadio: "",
  mesaneBosaltildiMiAciklama: "",
  hastaTumCamAsirlariCikarildiMiRadio: "",
  hastaTumCamAsirlariCikarildiMiAciklama: "",
  hastaOnluguVeBonesiGiyiliMiRadio: "",
  hastaSedyeKemerleriBagliMiRadio: "",
  ilacUygulamalariVarMiRadio: "",
  ilacUygulamalariVarMiAciklama: "",
  premedikasyonUygulamalariYapildiMiRadio: "",
  premedikasyonUygulamalariCheckbox: {
    hastaIstemedi: false,
    lokalAnestezi: false
  },
  premedikasyonUygulamalariAciklama: "",
  ameliyatSirasiKanUrunleriVarMiRadio: "",
  ameliyatSirasiKanUrunleriVarMiCheckbox: {
    varIse: false
  },
  ameliyatSirasiKanUrunleriVarMiAciklama: "",
  teslimTarihiPost: "",
  teslimEdenPost: "",
  teslimAlanPost: "",
  operasyonDoktorAdi: "",
  ameliyatHemsiresi: "",
  ameliyatAdi: "",
  bolgeIsaretlemesiYapildiMiPostRadio: "",
  bolgeIsaretlemesiYapildiMiPostCheckbox: {
    bilateral: false,
    sag: false,
    tekliOrgan: false,
    sol: false,
  },
  bolgeIsaretlemesiYapildiMiPostAciklama: "",
  allerjiVarMiPostRadio: "",
  allerjiVarMiPostAciklama: "",
  pansumanTemizMiPostRadio: "",
  pansumanTemizMiPostAciklama: "",
  kanamaVarMiPostRadio: "",
  kanamaVarMiPostAciklama: "",
  herhangiBirDrenMevcutMuPostRadio: "",
  herhangiBirDrenMevcutMuPostCheckbox: {
    evetIseYeriVeMiktari: false,
  },
  herhangiBirDrenMevcutMuPostAciklama: "",
  folaySondaVarMiPostRadio: "",
  folaySondaVarMiPostAciklama: "",
  nazogastrikSondaVarMiPostRadio: "",
  nazogastrikSondaVarMiPostAciklama: "",
  ameliyathanedeUygulananIlaclarVarMiPostRadio: "",
  ameliyathanedeUygulananIlaclarVarMiPostAciklama: "",
  kanTransfuzyonuYapilmisMiPostRadio: "",
  kanTransfuzyonuYapilmisMiPostCheckbox: {
    evetIseKacUnite: false,
  },
  kanTransfuzyonuYapilmisMiPostAciklama: "",
  hastadanPatolojiOrnegiGonderilmisMiPostRadio: "",
  hastadanPatolojiOrnegiGonderilmisMiPostCheckbox: {
    evetIseKacUnite: false,
  },
  hastadanPatolojiOrnegiGonderilmisMiPostAciklama: "",
}; 